import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import {
  MoreHorizontal,
  Pencil,
  Globe,
  GlobeLock,
  Trash2,
} from "lucide-react";
import type { AdminArticleListItem } from "@/types/article";
import type { ArticleAction } from "./article-columns";

interface ArticleActionsProps {
  article: AdminArticleListItem;
  onAction: (
    article: AdminArticleListItem,
    action: ArticleAction
  ) => void;
}

export function ArticleActions({ article, onAction }: ArticleActionsProps) {
  const isPublished = !!article.publishedAt;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="h-8 min-h-[44px] w-8 min-w-[44px] p-0 md:h-8 md:min-h-0 md:w-8 md:min-w-0"
          aria-label="Open article actions menu"
        >
          <span className="sr-only">메뉴 열기</span>
          <MoreHorizontal className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem
          onClick={() => onAction(article, "edit")}
          className="cursor-pointer"
        >
          <Pencil className="mr-1 h-4 w-4" />
          수정
        </DropdownMenuItem>
        {isPublished ? (
          <DropdownMenuItem
            onClick={() => onAction(article, "unpublish")}
            className="cursor-pointer"
          >
            <GlobeLock className="mr-1 h-4 w-4" />
            발행 취소
          </DropdownMenuItem>
        ) : (
          <DropdownMenuItem
            onClick={() => onAction(article, "publish")}
            className="cursor-pointer"
          >
            <Globe className="mr-1 h-4 w-4" />
            발행
          </DropdownMenuItem>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => onAction(article, "delete")}
          className="text-destructive focus:text-destructive cursor-pointer"
        >
          <Trash2 className="text-destructive mr-1 h-4 w-4" />
          삭제
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
